<div class="footer-section">
  <span>&#169; {{ currentYear }} All Rights Reserved</span>
  <div>
    <span class="footer-link" (click)="navigateToLink('/file-upload')">Upload a File</span>
    <span class="footer-link" (click)="navigateToLink('/feedback')">Send us Feedback</span>
    <span class="footer-link" (click)="navigateToLink('/privacy-policy')">Privacy & Policies</span>
    <span class="footer-link" (click)="navigateToLink('/terms-use')">Terms of Use</span>
    <span class="footer-link" (click)="navigateToLink('/support')">Support</span>
    <span class="footer-link" (click)="navigateToLink('/documentation')">Documentation</span>
  </div>
</div>
